const productTypeOptions = [{ label: '平台自有商品', value: 'owner' }, { label: '胜天半子', value: 'shenTian' }, { label: '其他平台', value: 'other' }];
const statusOptions = [{ label: '待付款', value: 0 }, { label: '待发货', value: 1 }, { label: '已发货', value: 2 }, { label: '已完成', value: 3 }, { label: '已关闭', value: 4 }, { label: '无效订单', value: 5 }, { label: '已退款', value: 6 }];
const sourceTypeOptions = [{ label: 'H5订单', value: 0 }, { label: 'app订单', value: 1 }, { label: '云听商城', value: 2 }, { label: '小程序', value: 3 }];
const payTypeOptions = [{ value: 1, label: '支付宝' }, { value: 2, label: '微信' }, { value: 3, label: '通联支付' }, { value: 5, label: '0元购' }, { value: 0, label: '未支付' }];
const operateOptions = [{ label: "批量发货", value: 1 }, { label: "关闭订单", value: 2 }, { label: "删除订单", value: 3 }];

const options = {
  productTypeOptions: productTypeOptions,
  statusOptions: statusOptions,
  sourceTypeOptions: sourceTypeOptions,
  payTypeOptions: payTypeOptions,
  operateOptions: operateOptions,
}
export default options



// WEBPACK FOOTER //
// ./src/utils/options.js